import { render, staticRenderFns } from "./DoctorDetail.vue?vue&type=template&id=4d65d1dc&"
import script from "./DoctorDetail.vue?vue&type=script&lang=js&"
export * from "./DoctorDetail.vue?vue&type=script&lang=js&"
import style0 from "./DoctorDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports